import { Component, NgZone, OnInit, signal, ViewChild, ChangeDetectorRef } from '@angular/core';

import { FormSummary } from '../shared/interfaces/form-summary';
import { DispatchFormSummary } from '../shared/interfaces/dispatch-form-summary';
import { Router, RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { UserService } from '../shared/services/user-service';
import { TokenService } from '../shared/services/token-service';
import { filter } from 'rxjs/operators';
import {
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
  RoutesRecognized,
} from '@angular/router';
import { FormsFlowService } from 'app/shared/services/forms-flow-service';

import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormTypeEnum } from 'app/shared/enums/form-type-enum';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
declare var $: any;
@Component({
  selector: 'app-main',
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatExpansionModule,
  ],
  templateUrl: './main.html',
  styleUrl: './main.scss',
  standalone: true,
})
export class Main implements OnInit {
  @ViewChild('sidenav') sidenav!: MatSidenav;

  isMobile = false;

  panelOpenState = false;
  staffData: any;
  FormType = FormTypeEnum;
  formSummaries: FormSummary[] = [];
  dispatchFormSummaries: DispatchFormSummary[] = [];
  collapseIds: Record<string, boolean> = {};
  sidebarToggle = false;
  display = false;
  ip = '';
  version = '';
  private openGroups = signal<Record<string, boolean>>({});
  private versionUrl = 'assets/version.json';

  get transferUtCod(): string {
    return this.dispatchFormSummaries?.length > 0
      ? this.dispatchFormSummaries[0].UtCod
      : this.staffData?.UtCod ?? '';
  }

  constructor(
    private http: HttpClient,

    private zone: NgZone,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    private tokenService: TokenService,
    // private formsFlowService: FormsFlowService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.formSummaries = [];
    this.collapseIds = {};
    this.dispatchFormSummaries = [];
    
    // 監聽路由事件，導航完成後清理 URL 中的 token
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      const url = window.location.href;
      if (url.includes('token=')) {
        const cleanUrl = url.replace(/[?&]token=[^&]*/, '').replace(/\?$/, '');
        window.history.replaceState({}, '', cleanUrl);
        console.log('[Main] 🔧 導航完成後清理 URL 中的 Token 參數');
      }
    });
    
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((result) => {
      this.isMobile = result.matches;
    });
  }

  ngOnInit(): void {
    // --- 【修改點 3：統一在 ngOnInit 監聽斷點】 ---
    this.breakpointObserver.observe(['(max-width: 960px)']).subscribe((result) => {
      this.isMobile = result.matches;

      // 核心邏輯：根據螢幕大小強制切換 sidenav 狀態
      if (this.sidenav) {
        if (this.isMobile) {
          // 平板以下：收起列表 (Over 模式)
          this.sidenav.close();
        } else {
          // 平板以上：展開列表 (Side 模式)
          this.sidenav.open();
        }
      }
      console.log('縮放偵測 - 是否為行動裝置:', this.isMobile);
    });
    const initialState: { [key: string]: boolean } = {};
    for (const summary of this.formSummaries) {
      initialState[this.keyOf(summary)] = true; // 一開始就展開
    }
    this.openGroups.set(initialState);

    this.fetchVersion();

   
    this.userService.getLoginUserData().subscribe((data) => {
      this.staffData = data;
      this.ip = data.Ip || ''; // 如果 data.Ip 不存在則給空字串
      console.log('登入者資料:', data);
    });

    this.userService.getFormSummaries().subscribe((data) => {
      this.formSummaries = data;
      this.cdr.detectChanges();
      // console.log(this.formSummaries, data);
    });
    // // //debugger;
    this.userService.getDispatchFormSummaries().subscribe((data) => {
      this.dispatchFormSummaries = data;
      this.display = data.length > 0 ? true : false;
      this.cdr.detectChanges();
    });
  }

  onDeactivate(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onActivate(component: any) {
    console.log('渲染了:', component.constructor.name);
  }

  signOut() {
    this.tokenService.removeLoginToken();
    document.location.href = 'https://i.nccu.edu.tw/';
  }

  toggle() {
    this.sidebarToggle = !this.sidebarToggle;
  }

  fetchVersion() {
    fetch('assets/version.json')
      .then((response) => response.json())
      .then((data) => {
        const storedVersion = localStorage.getItem('app_version');
        console.log('進入待處理表單版號:', data.version);
        console.log('進入待處理表單本地端版本號:', storedVersion);
        if (storedVersion !== data.version) {
          localStorage.setItem('app_version', data.version);
          location.reload(); // 強制刷新頁面
          const randomParam = new Date().getTime();
          window.location.href = window.location.href.split('?')[0] + '?nocache=' + randomParam;
        }
      })
      .catch((error) => {
        console.error('讀取 JSON 失敗:', error);
      });
  }

  // 產生唯一 key
  keyOf(formSummary: { UtCod: string | number; StaNum: string | number }): string {
    return `${formSummary.UtCod}-${formSummary.StaNum}`;
  }

  // 判斷群組是否展開
  isGroupOpen(formSummary: { UtCod: string | number; StaNum: string | number }): boolean {
    // debugger;
    return !!this.openGroups()[this.keyOf(formSummary)];
  }

  // 切換展開狀態
  toggleGroup(formSummary: { UtCod: string | number; StaNum: string | number }) {
    const key = this.keyOf(formSummary);
    const current = this.openGroups();
    this.openGroups.set({ ...current, [key]: !current[key] });
  }
}
